import React from "react";
import { Helmet } from "react-helmet";
import BannerSlider from "./BannerSlider";
import AboutUs from "./AboutUs";
import OurPurpose from "./OurPurpose";
import GrantsManagementHome from "./GrantsManagementHome";
import VideoCTA from "./VideoCTA";
import Benifits from "./Benifits";
import ReliabilitySecurity from "./ReliabilitySecurity";
import Illustrative from "./Illustrative";
import WhyChoose from "./WhyChoose";
import Resources from "./Resources";
import FAQ from "./FAQ";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>
          Nonprofit Software | Fundraising CRM | Grant Management CRM | Donor
          Management
        </title>
        <meta name="keywords" content="" />
        <meta
          name="description"
          content="Right Cause is a Nonprofit Software that comes with built-in charity specific features like Fundraising Management, Donation Management, Grant Management, Volunteer Management, Reporting and a lot more."
        />
      </Helmet>
      <div data-spy="scroll" data-target=".navbar" data-offset="40" id="home">
        <main id="homeCC">
          <BannerSlider />
          <AboutUs />
          <OurPurpose />
          <GrantsManagementHome />
          <VideoCTA />
          <Benifits />
          <ReliabilitySecurity />
          <Illustrative />
          <WhyChoose />
          <Resources />
          <FAQ />
        </main>
      </div>
    </>
  );
};

export default Home;
